(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("zotero-editor", [], factory);
	else if(typeof exports === 'object')
		exports["zotero-editor"] = factory();
	else
		root["zotero-editor"] = factory();
})(self, () => {
return 